import { fetchClearanceReportsUrl, fetchClearanceLabelUrl } from '../../utils/ConstantUtils'
import { getApiInstance } from '../axiosInterceptor'

/**
 * Fetches the list of clearance label reports
 * @param {Object} instance - MSAL instance
 * @param {Function} setRows - State setter for rows
 * @param {Function} setIsReloading - State setter for loading state
 * @returns {Promise<void>}
 */
export const fetchClearanceReports = async (instance, setRows, setIsReloading) => {
  setIsReloading(true)
  try {
    const response = await getApiInstance(instance).get(fetchClearanceReportsUrl)
    setRows(response.data)
  } catch (error) {
    console.error('Error fetching clearance reports:', error)
    throw error
  } finally {
    setIsReloading(false)
  }
}

/**
 * Fetches clearance label data for given keycodes
 * @param {Object} instance - MSAL instance
 * @param {Array<number>} keyCodes - Array of keycodes to fetch labels for
 * @returns {Promise<Object>} - API response
 */
export const fetchClearanceLabel = async (instance, keyCodes) => {
  try {
    const response = await getApiInstance(instance).post(fetchClearanceLabelUrl, {
      keyCode: keyCodes,
      requestType: 'clearance'
    })
    return response
  } catch (error) {
    console.error('Error fetching clearance labels:', error)
    throw error
  }
}
